import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';

const ACTIONS = {
    GET_ITEM_MONTH_SUCCESS: 'GET_ITEM_MONTH_SUCCESS',
    GET_ITEM_MONTH_ERROR: 'GET_ITEM_MONTH_SUCCESS',
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getItemForMonths = (idTeam,month) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/dashboards/${month}/team/${idTeam}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_ITEM_MONTH_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_ITEM_MONTH_ERROR, err));
            });
    };
};

export { ACTIONS, getItemForMonths };
